/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the edit operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useEditResults} from '@ion/dls/src/hooks/';
 *   const editResult = useEditResults('reducer');
 *
 * ```
 */
export const useEditResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {edit}}) => edit?.result);
};

export default useEditResults;
